import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useBrowseProductsByCategories } from './browse-products-by-categories.controller';
import { CategoryCard } from './category-card/category-card.component';
import { LeafCategoryCard } from './leaf-category-card/leaf-category-card.component';
import { ProductCard } from './product-card/product-card.component';

export const BrowseProductsByCategories = () => {
    const viewProps = useBrowseProductsByCategories();

    if (viewProps.isLoading) {
        return (
            <WizardScreenContainer
                footer={viewProps.canGoBack ? { onBack: viewProps.navigateBack } : undefined}
                header={{ title: CommonMessage.WIZARD.SHOP.DEFAULT }}>
                <div className='flex h-full w-full items-center justify-center py-12'>
                    <Spinner />
                </div>
            </WizardScreenContainer>
        );
    }

    return (
        <WizardScreenContainer
            footer={viewProps.canGoBack ? { onBack: viewProps.navigateBack } : undefined}
            header={{ title: CommonMessage.WIZARD.SHOP.DEFAULT, onBack: viewProps.canGoBack ? viewProps.navigateBack : undefined }}>
            {viewProps.currentCategory && <div className='text-foreground-default text-lg font-semibold'>{viewProps.currentCategory.name}</div>}
            {viewProps.branchCategories.length > 0 && (
                <div className='inline-flex flex-col items-start justify-start gap-3 self-stretch'>
                    <p className='font-medium'>{CommonMessage.OBJECTS.CATEGORY.PLURAL}</p>
                    <div className='grid w-full grid-cols-2 gap-2 self-stretch'>
                        {viewProps.branchCategories.map((category) => (
                            <CategoryCard
                                key={category.id}
                                category_id={category.id}
                                categoryAvailability={
                                    viewProps.isRecycleMode || viewProps.hasOrderPermission
                                        ? undefined
                                        : (viewProps.categoryAvailability?.[category.id] ?? null)
                                }
                                onClick={(cat) => viewProps.navigateToCategory(cat)}
                            />
                        ))}
                    </div>
                </div>
            )}
            {(viewProps.leafCategories.length > 0 || viewProps.products.length > 0) && (
                <div className='inline-flex flex-col items-start justify-start gap-3 self-stretch'>
                    <p className='font-medium'>{CommonMessage.OBJECTS.PRODUCT.PLURAL}</p>
                    <div className='flex flex-col gap-2 self-stretch'>
                        {viewProps.leafCategories.map((category) => (
                            <LeafCategoryCard
                                key={category.id}
                                category={category}
                                categoryAvailability={
                                    viewProps.isRecycleMode || viewProps.hasOrderPermission
                                        ? undefined
                                        : (viewProps.categoryAvailability?.[category.id] ?? null)
                                }
                                categoryAllowance={viewProps.isRecycleMode ? undefined : (viewProps.categoryAllowances?.[category.id] ?? null)}
                                onClick={(cat) => viewProps.navigateToCategory(cat)}
                            />
                        ))}
                        {viewProps.products.map((product) => (
                            <ProductCard
                                key={product.id}
                                product={product}
                                allowance={viewProps.isRecycleMode ? undefined : (viewProps.allowances?.[product.id] ?? null)}
                                certification={
                                    viewProps.isRecycleMode || viewProps.canOrderOutOfStock(product)
                                        ? undefined
                                        : (viewProps.certifications?.[product.id] ?? null)
                                }
                                certificationLoading={viewProps.isLoadingCertifications}
                                stock={
                                    viewProps.isRecycleMode || viewProps.canOrderOutOfStock(product)
                                        ? undefined
                                        : (viewProps.stockAvailability?.[product.id] ?? null)
                                }
                                hasStockInOtherSpots={
                                    viewProps.isRecycleMode || viewProps.canOrderOutOfStock(product)
                                        ? false
                                        : (viewProps.otherSpotsStockInfo?.[product.id] ?? false)
                                }
                                onClick={(p) => viewProps.onProductClick(p)}
                            />
                        ))}
                    </div>
                </div>
            )}
            {viewProps.productKits.length > 0 && (
                <div className='inline-flex flex-col items-start justify-start gap-3 self-stretch'>
                    <p className='font-medium'>{CommonMessage.OBJECTS.PRODUCT_KIT.PLURAL}</p>
                    <div className='flex flex-col gap-2 self-stretch'>
                        {viewProps.productKits.map((productKit) => (
                            <ProductCard
                                key={productKit.id}
                                product={productKit}
                                allowance={viewProps.allowances?.[productKit.id] ?? null}
                                certification={viewProps.certifications?.[productKit.id] ?? null}
                                certificationLoading={viewProps.isLoadingCertifications}
                                stock={viewProps.stockAvailability?.[productKit.id] ?? null}
                                hasStockInOtherSpots={viewProps.otherSpotsStockInfo?.[productKit.id] ?? false}
                                onClick={(product) => viewProps.onProductClick(product)}
                            />
                        ))}
                    </div>
                </div>
            )}
        </WizardScreenContainer>
    );
};
